// extracted by mini-css-extract-plugin
export default {"selectWrapper":"Select_selectWrapper__c4lf-","arrow":"Select_arrow__tthjR","placeholder":"Select_placeholder__gM1cv","select":"Select_select__nRJm6","option":"Select_option__w8uTG"};